import BaseApi from './index';

export default {
  // 부대 목록 조회
  getCorps() {
    return BaseApi().get('/corps');
  },
  // 관리자 로그인
  login(form) {
    return BaseApi(true).post('/login/admin', form);
  },
  // 관리자 로그인 정보 업데이트
  updateInfo() {
    return BaseApi().put('/user/admin-info');
  },
  // 관리자 계정 목록 조회
  getAccountList(form) {
    return BaseApi().get('/account/list', { params: form });
  },
  // 관리자 비밀번호 변경
  passwordModify(form) {
    return BaseApi().put('/account/password-modify', form);
  },
  // 관리자 계정 생성
  createAccount(form) {
    return BaseApi().post('/account/create', form);
  },
  // 관리자 비밀번호 초기화
  resetPassword(form) {
    return BaseApi().put(`/account/password-reset/${form.admId}`);
  },
  // 관리자 계정 삭제
  deleteAccount(form) {
    return BaseApi().delete(`/account/delete/${form.admId}`);
  },
  // 환자 목록 조회
  getSoldierList(form) {
    return BaseApi().get('/soldier/list', { params: form });
  },
  // 환자 등록
  createSoldier(form) {
    return BaseApi().post('/soldier/create', form);
  },
  // 환자 정보 조회
  getSoldierInfo(form) {
    return BaseApi().get('/soldier/info', { params: form });
  },
  // 환자 정보 수정
  modifySoldier(form) {
    return BaseApi().put('/soldier/modify', form);
  },
  // 환자 정보 삭제
  deleteSoldier(form) {
    return BaseApi().delete(`/soldier/delete/${form.id}`);
  },
  // 환자 구강 상태 메인
  getOralCondition(form) {
    return BaseApi().get('/oralCondition/main', { params: form });
  },
  // 환자 구강 상태 리포트
  getOralConditionReport(form) {
    return BaseApi().get('/oralCondition/report', { params: form });
  },
  // 기간별 통계
  getStatisticsPeriod(form) {
    return BaseApi().get('/statistic/period', { params: form });
  },
  // 치아별 구강상태
  getStatisticsOral(form) {
    return BaseApi().get('/statistic/part', { params: form });
  },
  // 장병 목록 조회 > 엑셀 다운로드
  getSoldierListExcel(form) {
    return BaseApi().get('/soldier/list-excel', {
      params: form,
      responseType: 'blob',
    });
  },
  // 촬영 사진 목록 조회
  getToothPictures(form) {
    return BaseApi().get('/toothColoring/pictures', { params: form });
  },
};
